import { Component } from "react";
import { MdRotateLeft, MdFilterList } from "react-icons/md";
import { ToolTips, TOGGLE_FILTERS_TOOLTIP, RESET_FILTERS_TOOLTIP } from "utils/hiddenToolTips";
import { trellisPalette } from "../../../custom/analytics/palettes";
import ColumnSelector from "components/core/blocks/ColumnSelector";
import { cx } from "../../../../../styled-system/css";
import { PaginationWidget } from "../../../table/Pagination";
import { functionalUpdate } from "@tanstack/react-table";

export default class ReactTablePagination extends Component {
  getSafePage = (page) => {
    if (Number.isNaN(page)) {
      page = this.props.page;
    }
    return Math.min(Math.max(page, 0), this.props.pages - 1);
  };

  changePage = (nextPage) => {
    nextPage = functionalUpdate(nextPage, this.props.page);
    nextPage = this.getSafePage(nextPage);
    this.props.onPageChange(nextPage);
  };

  resetFilters = () => {
    const table = document.querySelector(".ReactTable");
    const filterRow = table?.querySelector(".-filters");
    const dropdownFilters = filterRow?.querySelectorAll("select");
    const inputFilters = filterRow?.querySelectorAll("input[type=text]");

    this.props.updateSearch("");

    if (this.props.setSortState) {
      this.props.setSortState();
    }

    if (inputFilters) {
      inputFilters.forEach((filter) => {
        filter.value = "";
      });
    }
    if (dropdownFilters) {
      dropdownFilters.forEach((filter) => {
        filter.selectedIndex = 0;
        filter.value = "all";
      });
    }
  };

  toggleFilter = () => {
    this.props.setShowFilters(!this.props.showFilters);
  };

  render() {
    const {
      // Computed
      pages,
      // Props
      page,
      pageSize,
      onPageSizeChange,
      className,
    } = this.props;

    return (
      <>
        <div className={`${cx(className, "-pagination")} mb-0`} style={this.props.style}>
          <div className="filter-controls" style={{ display: this.props.hideFilters ? "none" : "inherit" }}>
            <button
              className="btn-toggle-filters"
              style={{
                background: "#fff",
                color: "#000",
                fontSize: "2rem",
                padding: "1rem",
                position: "relative",
              }}
              onClick={(e) => {
                this.toggleFilter(e);
              }}
            >
              <ToolTips toolTip={TOGGLE_FILTERS_TOOLTIP} position={"top"} />
              <MdFilterList className="icon" style={{ fontSize: "24px", fontWeight: "bold" }} />
            </button>
            <button
              className="btn-reset-filters "
              style={{
                background: "#fff",
                color: "#000",
                fontSize: "2rem",
                padding: "1rem",
                position: "relative",
              }}
              onClick={() => {
                this.resetFilters();
                this.props.clearFilters();
              }}
            >
              <ToolTips toolTip={RESET_FILTERS_TOOLTIP} position={"top"} />
              <MdRotateLeft style={{ fontSize: "24px", fontWeight: "bold" }} />
            </button>
            {this.props.columnSelectorProps && (
              <div style={{ padding: "1rem" }}>
                <ColumnSelector {...this.props.columnSelectorProps} />
              </div>
            )}
            {this.props.additionalFilters && <div style={{ padding: "1rem" }}>{this.props.additionalFilters}</div>}
            {this.props.searchFilter && (
              <div
                style={{
                  padding: "1rem",
                }}
              >
                {this.props.searchFilter}
              </div>
            )}
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              flexDirection: "column",
              justifyContent: "space-between",
              padding: "auto 1rem",
            }}
          >
            <span
              style={{
                fontWeight: 500,
                margin: "auto 1rem auto 0",
                fontSize: "1.5rem",
              }}
            >
              {this.props.selectedProductCount} Products Selected
            </span>
            {this.props.selectedProductCount > 0 && !this.props.hideClearAll && (
              <span
                onClick={() => this.props.clearSelectedProducts()}
                style={{
                  color: trellisPalette[0],
                  fontWeight: 600,
                  fontSize: "1.2rem",
                  cursor: "pointer",
                  display: this.props.hideFilters ? "none" : "inherit",
                }}
              >
                Clear All
              </span>
            )}
          </div>
          <PaginationWidget
            hideResultsCount
            currentPage={page}
            setCurrentPage={this.changePage}
            pageSize={pageSize}
            setPageSize={onPageSizeChange}
            totalPages={pages}
          />
        </div>
        {this.props.children && <div className="w-100 d-flex justify-content-center">{this.props.children}</div>}
      </>
    );
  }
}
